
import urls from '../Urls'
import axios from 'axios'

export const CHILD_API_ENDPOINTS = {
  JOB_LIST: 'jobs',
  JOB_DETAIL_LIST: 'details',
  JOB_DETAIL_PAGE: 'job',
  RUN_JOB: 'runJob'
}

function getJobSummariesApiEndPoint () {
  return urls.salesForceAdminApiController() + '/' + CHILD_API_ENDPOINTS.JOB_LIST
}

function getJobDetailPageEndPoint () {
  return urls.salesForceAdminController() + '/' + CHILD_API_ENDPOINTS.JOB_DETAIL_PAGE
}

function getJobDetailsApiEndPoint (jobId) {
  let params = '?id=' + jobId
  return urls.salesForceAdminApiController() + '/' + CHILD_API_ENDPOINTS.JOB_DETAIL_LIST + params
}

function getRunJobApiEndPoint () {
  return urls.salesForceAdminApiController() + '/' + CHILD_API_ENDPOINTS.RUN_JOB
}

function runJob (data) {
  return axios.post(getRunJobApiEndPoint(), data)
}

export default {
  getJobSummariesApiEndPoint: getJobSummariesApiEndPoint,
  getJobDetailPageEndPoint: getJobDetailPageEndPoint,
  getJobDetailsApiEndPoint: getJobDetailsApiEndPoint,
  runJob: runJob
}



// WEBPACK FOOTER //
// ./src/js/endpoints/admin/SalesforceAdminService.js